import { cache } from 'react';
import { APP_CONFIG_DEFAULTS } from '@/app-config';
export const CONFIG_ENDPOINT = process.env.NEXT_PUBLIC_APP_CONFIG_ENDPOINT;
export const SANDBOX_ID = process.env.SANDBOX_ID;
export const THEME_STORAGE_KEY = 'theme-mode';
export const THEME_MEDIA_QUERY = '(prefers-color-scheme: dark)';
export function getOrigin(headers) {
    const host = headers.get('host');
    const proto = headers.get('x-forwarded-proto') || 'https';
    return `${proto}://${host}`;
}
/**
 * Agent used when no agent id is supplied explicitly (via the `agentId` query
 * param, the script tag's `data-agent-id`, or the SANDBOX_ID env var).
 *
 * This previously fell back to `origin.split('.')[0]`, which produced values
 * like "https://voice-agents-embed" from the deployed origin. That is not a
 * valid agent id, so the worker could not resolve the agent's config and no
 * transcripts were saved.
 */
export const DEFAULT_AGENT_ID = '0b118322-9892-4428-bcac-22e5a02a539c';
export function getSandboxId() {
    return SANDBOX_ID !== null && SANDBOX_ID !== void 0 ? SANDBOX_ID : DEFAULT_AGENT_ID;
}
// https://react.dev/reference/react/cache#caveats
// > React will invalidate the cache for all memoized functions for each server request.
export const getAppConfig = cache(async (origin, sandboxIdAttribute) => {
    if (CONFIG_ENDPOINT) {
        const sandboxId = sandboxIdAttribute !== null && sandboxIdAttribute !== void 0 ? sandboxIdAttribute : getSandboxId();
        try {
            const response = await fetch(CONFIG_ENDPOINT, {
                cache: 'no-store',
                headers: { 'X-Sandbox-ID': sandboxId },
            });
            const remoteConfig = await response.json();
            const config = Object.assign({}, APP_CONFIG_DEFAULTS);
            for (const [key, entry] of Object.entries(remoteConfig)) {
                if (entry === null)
                    continue;
                if (key in config &&
                    typeof config[key] === entry.type &&
                    typeof config[key] === typeof entry.value) {
                    // @ts-expect-error I'm not sure quite how to appease TypeScript, but we've thoroughly checked types above
                    config[key] = entry.value;
                }
            }
            return config;
        }
        catch (error) {
            console.error('!!!', error);
        }
    }
    return APP_CONFIG_DEFAULTS;
});
